module.exports = __webpack_public_path__ + "static/img/pic_youxia@2x.847010c.png";


//////////////////
// WEBPACK FOOTER
// ./static/newStatic/img/guide/pic_youxia@2x.png
// module id = DoQH
// module chunks = 88